var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Frota-Principal"},[_c('PageTitle',{attrs:{"icon":"fa fa-bus","main":"Frota","sub":"Soltura da frota"}}),_c('div',{staticClass:"Sac-Principal"},[_c('b-card',{attrs:{"no-body":""}},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Frota","active":""}},[_c('FrotaMonitoramento')],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }